import { FieldDefinitionTypes, SearchField } from "@/shared/search/search.types";
import { LanguageWithWildcard } from "@/shared/services/graphql/generated/consumer-graph-types";

/**
 * Expands text-type search fields into language-specific variants (primary + fallback),
 * while passing through non-text fields unchanged.
 */
export function localizeSearchFields(
    searchEntries: SearchField[],
    dataQueryLanguages: LanguageWithWildcard[]
): SearchField[] {
    return searchEntries.flatMap((entry) => {
        if (entry.fieldType === FieldDefinitionTypes.text) {
            return [
                {
                    referencedId: `${entry.referencedId}_${dataQueryLanguages[0]}`,
                    fieldType: entry.fieldType,
                    boost: entry.boost,
                },
                {
                    referencedId: `${entry.referencedId}_${dataQueryLanguages[1]}`,
                    fieldType: entry.fieldType,
                    boost: entry.boost,
                },
            ];
        }
        return [entry];
    });
}
